import { useContext } from 'react';

import { SheetsContext } from '../Contexts/index';

const useSheets = () => {
  const context = useContext(SheetsContext);

  return context;
};

export default useSheets;
